<div class="!{{customClass}}"
[ngClass]="{'sml-option-tabs-grid' : tabView,
  'sml-option-control-grid ':!tabView && !storyTeller,
  'sml-option-control-grid-2 ':!tabView && storyTeller && value,
  'sml-option-control-grid-3 ':!tabView && storyTeller && !value
}">
  <div class="sml-option-control-item" *ngFor="let key of getEnumKeys(); let i = index" [ngClass]="{'tw-min-h-[82px]': customInputHeight}">
    <label [for]="groupIdentifier + '-input-' + i" class="sml-option-control-label tw-w-full tw-flex tw-items-center tw-p-3   tw-cursor-pointer {{adjustHeight}}"
    [ngClass]="{
      'tw-border-primary-200 tw-bg-primary-100 tw-text-dark-grey': isChecked(options[key]) && !tabView,
      'tw-border-mercury-200 tw-bg-white tw-text-grey-750': !isChecked(options[key]),
      'tw-h-full tw-items-baseline': adjustHeight,
      '!tw-bg-[#F8F8F8] !tw-cursor-not-allowed !tw-text-[#828485]': getDisabledOption(options[key]),
      'tw-bg-[#4089A5] tw-text-white': isChecked(options[key]) && tabView,
      'tw-rounded-tl-lg tw-rounded-bl-lg !tw-border-l  !tw-border-[#e3e3e3]': i === 0 && tabView,
      'tw-rounded-tr-lg tw-rounded-br-lg !tw-border-r !tw-border-[#e3e3e3]': i === 1 && tabView,  
      ' tw-rounded-lg tw-border tw-border-solid' : !tabView,
      '!tw-border-y' : tabView, 
      '!tw-border-x': tabView && isRegistrationItem,
      '!tw-bg-[#5E8E481A]': storyTeller && value && i===1,
      '!tw-bg-[#D11A2A1A]': storyTeller && !value && i===0
    }">
      <div class="tw-flex tw-flex-col tw-overflow-hidden">
        <div class="tw-flex tw-items-center">
          <input [type]="inputType" [id]="groupIdentifier + '-input-' + i" [name]="name" [value]="options[key]" [checked]="isChecked(options[key])"
            (change)="onInputChange(options[key])"
            [class]="'sml-option-control tw-border tw-border-solid tw-mr-[7.5px] tw-relative tw-cursor-pointer tw-flex-grow-0 tw-flex-shrink-0  ' + (inputType === 'checkbox' ? 'tw-w-5 tw-h-5 tw-basis-5 tw-rounded !tw-mr-2.5' : 'tw-w-4 tw-h-4 tw-basis-4 tw-rounded-full tw-appearance-none') "
            [ngClass]="{
              'tw-border-primary-700 after:tw-scale-100': isChecked(options[key]) && !storyTeller,
              'tw-border-mercury-200 tw-bg-surface-100 after:tw-scale-0': !isChecked(options[key]),
              'tw-border-[#5E8E48] after:tw-scale-100': isChecked(options[key]) && storyTeller && value && i===1,
              'tw-border-[#D11A2A] after:tw-scale-100': isChecked(options[key]) && storyTeller && !value && i===0
            }"
            [disabled]="getDisabledOption(options[key])" />
          <div class="sml-option-control-name tw-font-medium tw-text-sm" id="option-text-{{ i }}"
          [ngClass]="{ 'tw-text-[#3C4243]': !isChecked(options[key]) && storyTeller,
            'tw-text-[#041519]': isChecked(options[key]) && storyTeller}">
            {{ key }}
          </div>
        </div>
        <div *ngIf="showSubheadings && subheadings[key]" class="sml-option-control-text tw-text-[12px] tw-leading-4 tw-font-medium"
          [ngClass]="inputType === 'checkbox' ? 'tw-pl-[30px]' : 'tw-pl-[24px]'"
          [ngClass]="{'tw-pl-[30px]' : inputType==='checkbox',
            'tw-pl-[22px]' : inputType!=='checkbox',
            'tw-text-mercury-600': !isChecked(options[key]) && storyTeller,
            'tw-text-[#122327]': isChecked(options[key]) && storyTeller
          }">
          {{ subheadings[key] }}
        </div>
      </div>
    </label>
  </div>
</div>
